import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { auth, db } from '../../firebase'
import Branches from '../../sub-components/Branches'
import CommonHeader from '../../sub-components/CommonHeader'
import Footer from '../../sub-components/Footer'
import Booktable from './Booktable'
import Branchinfo from './Branchinfo'
import Gallery from './Gallery'
import Reviews from './Reviews'
import bg from "./assets/mall-dedicated-banner.png"
import Menu from "./Menu"
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { toast } from 'react-toastify'
import Map from './Map'


function RestaurantDetails() {
  const {branchId} = useParams()
  const [post, setPost] = useState()
  const [countReviews, setCountReviews] = useState(0)
  const [ratings, setRatings] = useState([])
  const [see,setSee] = useState()

  const likePost = () =>{
    // Alert.alert("Be Aware", "You liked the post!") 
    db.collection("users").doc(auth?.currentUser?.uid).collection("FavouritesRestaurants").where("fromId", "==", auth?.currentUser?.uid).where("branchId", "==",branchId ).get().then(
        snap => {
          if (snap.docs.length > 0) {
            db.collection("users").doc(auth?.currentUser?.uid).collection("FavouritesRestaurants").doc(branchId).delete().then(function() {
            }).catch(function(error) {
                alert("Error removing post: ", error);
            });                
        
          } else {
            db.collection("users").doc(auth?.currentUser?.uid).collection("FavouritesRestaurants").doc(branchId).set({
              fromId: auth?.currentUser?.uid,
              branchId,
              type:'restaurants',
              branchId,
              timestamp:Date.now(),  
              liked:true,
              branchImg:post?.branchImg,  
              branchName:post?.branch,  
              status:post?.status,
              closingTime:post?.closingTime,
              openingTime:post?.openingTime,
              restaurant:post?.restaurant,           
              })
              toast.success("Marked this restaurant as favourite")
          }
        }
      )
}


useEffect(() => {
  db.collection('users').doc(`${auth?.currentUser?.uid}`).collection("FavouritesRestaurants").doc(branchId).onSnapshot((doc) => {
      setSee(doc.data());
  });
}, [])

  useEffect(() => {
    db.collection('branches').doc(`${branchId}`).onSnapshot((doc) => {
      setPost(doc.data());
    });
}, [])
  useEffect(() => {
      db.collection('branches').doc(branchId).collection("reviews")
     .onSnapshot(snapshot => (
      setCountReviews(snapshot.docs.length)
     ))
  }, []);
    useEffect(() => {
      db.collection('branches').doc(`${branchId}`).collection("reviews").onSnapshot(snapshot => {
        setRatings(snapshot.docs.map(doc => ({
              id: doc.id,
              post: doc.data(),
          })));
      })
  }, []);

  function abbrNum(number, decPlaces) {
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10,decPlaces);
  
    // Enumerate number abbreviations
    var abbrev = [ "K", "M", "B", "T" ];
  
    // Go through the array backwards, so we do the largest first
    for (var i=abbrev.length-1; i>=0; i--) {
  
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10,(i+1)*3);
  
        // If the number is bigger or equal do the abbreviation
        if(size <= number) {
             // Here, we multiply by decPlaces, round, and then divide by decPlaces.
             // This gives us nice rounding to a particular decimal place.
             number = Math.round(number*decPlaces/size)/decPlaces;
  
             // Add the letter for the abbreviation
             number += abbrev[i];
  
             // We are done... stop
             break;
        }
    }
  
    return number;
  }

  const totalRatings = (ratings.reduce((a,v) =>  a = a + v.post.rating , 0 ))
  const numberOfRatings = ratings.length
  const rating = totalRatings / numberOfRatings
  var a = Math.round(rating * 10) / 10
  return (
    <div>
    <div>
    <CommonHeader/>
      <section className="restaurant-detailed-banner">
        <div className="text-center">
          <img style={{marginTop:-5}}  className="img-fluid cover" src={bg} />
        </div>
        <div className="restaurant-detailed-header">
          <div className="container">
            <div className="row d-flex align-items-end">
              <div className="col-md-8">
                <div className="restaurant-detailed-header-left">
                  <img className="img-fluid mr-3 float-left" alt="osahan" src={post?.branchImg} />
                  <h2 className="text-white">{post?.branch}</h2>
                  <p className="text-white mb-1"><i className="icofont-location-pin" /> {post?.branchAddress}<span className="badge badge-success">OPEN</span>
                  </p>
                  <p className="text-white mb-0"><i className="icofont-food-cart" />{post?.restaurant}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="restaurant-detailed-header-right text-right">
                  <button className="btn btn-success" type="button"><i className="icofont-clock-time" /> {post?.openingTime}–{post?.closingTime}
                  </button>
                  <h6 className="text-white mb-0 restaurant-detailed-ratings"><span className="generator-bg rounded text-white"><i className="icofont-star" /> {numberOfRatings === 0 ?(<>0</>):(<>{a}</>)}</span> Rating(s)<i className="ml-3 icofont-speech-comments" /> {abbrNum(countReviews,0)} review(s)</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section></div>
    <section className="offer-dedicated-nav bg-white border-top-0 shadow-sm">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <span className="restaurant-detailed-action-btn float-right">
              {auth?.currentUser?.uid ?(
                <>
                           {see?.liked === true ?(
                        <button onClick={likePost} className="btn btn-light btn-sm border-light-btn" type="button"><FavoriteIcon  style={{color: '#e74c3c'}}/> Marked as Favourite</button>
                        ):(
                          <button onClick={likePost} className="btn btn-light btn-sm border-light-btn" type="button"><FavoriteBorderOutlinedIcon  className="ti-heart"/> Mark as Favourite</button>
                        )} 
                </>
              ):(
                <>
                                          <button onClick={() => alert("Kindly Sign In first.\nThanks!")} className="btn btn-light btn-sm border-light-btn" type="button"><FavoriteBorderOutlinedIcon  className="ti-heart"/> Mark as Favourite</button>
                </>
              )}

            </span>
            <ul className="nav" id="pills-tab" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" id="branches" data-toggle="pill" href="#pills-order-online" role="tab" aria-controls="pills-order-online" aria-selected="true">Order Online</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="pills-gallery-tab" data-toggle="pill" href="#pills-gallery" role="tab" aria-controls="pills-gallery" aria-selected="false">Gallery</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="pills-restaurant-info-tab" data-toggle="pill" href="#pills-restaurant-info" role="tab" aria-controls="pills-restaurant-info" aria-selected="false">Restaurant Info</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="pills-book-tab" data-toggle="pill" href="#pills-book" role="tab" aria-controls="pills-book" aria-selected="false">Map Location</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="pills-reviews-tab" data-toggle="pill" href="#pills-reviews" role="tab" aria-controls="pills-reviews" aria-selected="false">Ratings &amp; Reviews ({abbrNum(countReviews,0)})</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section className="offer-dedicated-body pt-2 pb-2 mt-4 mb-4">
      <div className="container">
        <div className="row">
          <div className="">
            <div className="offer-dedicated-body-left">
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-order-online" role="tabpanel" aria-labelledby="branches">
                 <Menu branchId={branchId}/>
                </div>
                <div className="tab-pane fade" id="pills-gallery" role="tabpanel" aria-labelledby="pills-gallery-tab">
                 <Gallery/>
                </div>
                <div className="tab-pane fade" id="pills-restaurant-info" role="tabpanel" aria-labelledby="pills-restaurant-info-tab">
                <Branchinfo branchId={branchId}/>
                </div>
                <div className="tab-pane fade" id="pills-book" role="tabpanel" aria-labelledby="pills-book-tab">
                {/* <iframe name="gMap" src={`https://www.google.com/maps/embed/v1/place?q=${post?.latitude},${post?.longitude}&key=AIzaSyCAawMnC6vfUa40ZNFsLN-ov7Pa4DjcUrM`}></iframe> */}
                <Map lat={post?.latitude} lng={post?.longitude} branchAddress={post?.branchAddress}/>
                </div>
                <div className="tab-pane fade" id="pills-reviews" role="tabpanel" aria-labelledby="pills-reviews-tab">
              <Reviews branchId={branchId}/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <Footer/>
    </div>
  )
}

export default RestaurantDetails